import { parseCssPx } from '../../../../utils/cssUtil';

/**
 * Calculates the actual rendered width of a table cell border at the current browser zoom.
 */
export const getBorderRenderedWidth = (tdElement: HTMLTableCellElement | null): number => {
    if (!tdElement) return 1;

    return parseCssPx(getComputedStyle(tdElement).borderBottomWidth) || 1;
};
